/* eslint-disable @typescript-eslint/no-explicit-any */
// treeRules.tsx
import React from "react";

import { TreeNodeRoute, TreeNodeType } from "../components/InspectionRouteTree/types/treeNode";
import { EquipmentInspectionStatus } from "./utils/enumEquipmentInspectionStatus";

import { NodeExtras } from "./NodeExtras";

/* ============================================================
   ESTILOS DE LINHA
============================================================ */
export const rowStyle = (node: TreeNodeRoute): React.CSSProperties => {
    // Equipamentos inspecionados = verde claro
    if (node.type === TreeNodeType.ELEMENT && node.status === EquipmentInspectionStatus.INSPECTED) {
        return {
            backgroundColor: "#e6ffe5",
            borderColor: "#e6ffe5",
        };
    }

    // Equipamentos não inspecionados = cinza claro
    if (node.type === TreeNodeType.ELEMENT && node.status === EquipmentInspectionStatus.NOT_INSPECTED) {
        return {
            backgroundColor: "#f3f3f3",
            borderColor: "#f3f3f3",
        };
    }

    return {};
};

/* ============================================================
   COMPONENTES EXTRAS (renderNodeExtras)
============================================================ */
export const handleRenderNodeExtras = (
    node: TreeNodeRoute,
    update: (id: string, updater: (n: TreeNodeRoute) => TreeNodeRoute) => void,
    isViewMode = false,
    onStatusChange?: (id: string, status: EquipmentInspectionStatus) => void,
    onFinishGroup?: (id: string) => void
) => {
    return (
        <NodeExtras
            node={node}
            update={update}
            isViewMode={isViewMode}
            onStatusChange={onStatusChange}
            onFinishGroup={onFinishGroup}
        />
    );
};
